import ModalContainer from "@/components/modalContainer";
import { useTrans } from "@/translations";

export const DeleteFileModal: React.FC<{
  filename: string;
  isLoading?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}> = ({ filename, isLoading, onConfirm, onCancel }) => {
  const { t } = useTrans();
  return (
    <ModalContainer
      title={"actions:deleteFile"}
      onConfirmText="actions:confirm"
      onConfirm={onConfirm}
      onCancel={onCancel}
      onConfirmLoading={isLoading}
      onConfirmDisabled={isLoading}
    >
      <div className="pt-3">
        <p>
          {t("hints:areYouSureDelete", {
            name: filename,
          })}
        </p>
      </div>
    </ModalContainer>
  );
};
